const doc = [({"en":({"js":({"admin":({"teams":({"edit":({"add_new_team":"Add new team", "edit_team":"Edit team: %{name}", "the_team_was_saved":"The team was saved"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;